import { render, staticRenderFns } from "./JobAppealPointPc.vue?vue&type=template&id=5bef4de3&scoped=true"
import script from "./JobAppealPointPc.vue?vue&type=script&lang=js"
export * from "./JobAppealPointPc.vue?vue&type=script&lang=js"
import style0 from "./JobAppealPointPc.vue?vue&type=style&index=0&id=5bef4de3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bef4de3",
  null
  
)

export default component.exports